import Langs from './Langs';
export default Langs;